<div class="animated fadeIn">
  @if (profile.loading) { <p role="status">会員情報を取得しています。</p> }
  @if (profile.loadError) {
    <div class="alert alert-warning" role="alert">{{ profile.loadError }}
      <button type="button" class="btn btn-blue text-white" (click)="profile.refresh()" [disabled]="profile.loading || profile.busy">表示を再取得</button>
      <button type="button" class="btn btn-blue text-white" (click)="loginAgain()" [disabled]="profile.busy">再ログイン</button>
    </div>
  }
  @if (profile.operation.phase === 'unknown' || profile.operation.phase === 'saved-stale') {
    <div class="alert alert-warning" role="alert">{{ profile.operation.message }}
      <button type="button" class="btn btn-blue text-white" (click)="profile.refresh()" [disabled]="profile.loading">表示を再取得</button>
      @if (profile.operation.phase === 'unknown') {
        <label class="d-block"><input type="checkbox" [(ngModel)]="outcomeChecked"> 会員情報・再ログインまたは店舗への照会で、更新結果を確認しました</label>
        <button type="button" class="btn btn-blue text-white" (click)="acknowledgeOutcome()" [disabled]="!outcomeChecked || profile.loading">確認を完了して編集を再開</button>
      }
    </div>
  }

  <div class="row sfapp-container">
    <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          <span><i class="fa s-icon-member"></i>&nbsp;会員情報</span>
        </div>
        <div class="card-body">
          <form novalidate name="memberEditForm">
          <div style="height: 1px"></div>
          <strong>基本情報</strong>
          <hr />
          <table class="table border font-md-10px">
            <tr>
              <td class="table-blue border border-blue" style="width: 30%">在籍店舗</td>
              <td style="width: 70%">{{ member.studio?.name }}</td>
            </tr>
            <tr>
              <td class="table-blue border border-blue">会員ID</td>
              <td>{{ member.memberCode }}</td>
            </tr>
            <tr>
              <td class="table-blue border border-blue">区分コース</td>
              <td>{{ member.studioPlan?.name }}</td>
            </tr>
            <tr>
              <td class="table-blue border border-blue">支払方法</td>
              <td class="d-flex justify-content-between">
                <span>{{ paymentMethod.name }}</span>
              </td>
            </tr>
            <tr>
              <td class="table-blue border border-blue">住所</td>
              <td>〒{{ member.zip }} {{ member.province }} {{ member.city }} {{ member.area }} {{ member.address }}</td>
            </tr>
            <tr>
              <td class="table-blue border border-blue">電話番号</td>
              <td>{{ member.phone }}</td>
            </tr>
            <tr>
              <td class="table-blue border border-blue">メールアドレス</td>
              <td class="d-flex justify-content-between">
                <span>{{ member.email }}</span>
                <button type="button" class="btn btn-blue text-white" data-target="#updateEmailModal" [disabled]="profile.blocked || profile.loading || !!profile.loadError" title="メールアドレスの変更" (click)="openEditor('email', $event)"><i class="fa s-icon-edit"></i></button>
              </td>
            </tr>
            <tr>
              <td class="table-blue border border-blue">ログインID</td>
              <td class="d-flex justify-content-between">
                <span>{{ member.loginId }}</span>
                <button type="button" class="btn btn-blue text-white" data-target="#updateLoginIdModal" [disabled]="profile.blocked || profile.loading || !!profile.loadError" title="ログインIDの変更" (click)="openEditor('loginId', $event)"><i class="fa s-icon-edit"></i></button>
              </td>
            </tr>
            <tr>
              <td class="table-blue border border-blue">パスワード</td>
              <td class="d-flex justify-content-between">
                <span>********</span>
                <button type="button" class="btn btn-blue text-white" data-target="#changePasswordModal" [disabled]="profile.blocked || profile.loading || !!profile.loadError" title="パスワードの変更" (click)="openEditor('password', $event)"><i class="fa s-icon-edit"></i></button>
              </td>
            </tr>
          </table>
          <br /><br />
          <strong>緊急連絡先</strong>
          <hr />
          <table class="table table-bordered font-md-10px">
            <tr>
              <td class="table-blue border border-blue" style="width: 30%">氏名（漢字）</td>
              <td class="d-flex justify-content-between border-0">
                <span>{{ member.emLastName }} {{ member.emFirstName }}</span>
                <button type="button" class="btn btn-blue text-white d-inline-block d-md-none" data-target="#updateEmModal" [disabled]="profile.blocked || profile.loading || !!profile.loadError" title="緊急連絡先の変更" (click)="openEditor('emergency', $event)"><i class="fa s-icon-edit"></i></button>
              </td>
              <td class="d-none d-md-table-cell text-center" rowspan="4" style="width: 10%">
                <button type="button" class="btn btn-blue text-white" data-target="#updateEmModal" [disabled]="profile.blocked || profile.loading || !!profile.loadError" title="緊急連絡先の変更" (click)="openEditor('emergency', $event)"><i class="fa s-icon-edit"></i></button>
              </td>
            </tr>
            <tr>
              <td class="table-blue border border-blue">氏名（かな）</td>
              <td>{{ member.emLastNameKana }} {{ member.emFirstNameKana }}</td>
            </tr>
            <tr>
              <td class="table-blue border border-blue">続柄</td>
              <td>{{ relationship }}</td>
            </tr>
            <tr>
              <td class="table-blue border border-blue">電話番号</td>
              <td>{{ member.emPhone }}</td>
            </tr>
          </table>
          <br /><br />
          </form>
        </div>
      </div>
    </div>
  </div>

  <!-- 支払方法変更・登録 Modal -->
  <div class="modal fade" id="updatePaymentModal" tabindex="-1" role="dialog" aria-labelledby="updatePaymentModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="updatePaymentModalLabel"><i class="fa s-icon-edit"></i>&nbsp;支払方法変更・登録</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <form novalidate #updatePaymentForm="ngForm">
          <div class="modal-body">
            <div class="form-group row">
              <label class="col-md-12 col-form-label">支払方法: クレジットカード</label>

              @if (singlePayment.paymentMethod == '0') {
                <label class="col-md-12 col-form-label">銀行コード</label>
                <div class="col-md-12 form-group">
                  <input type="text" class="form-control col-md-12" [(ngModel)]="singlePayment.btBankCode"
                         name="btBankCode" placeholder="銀行コードを半角数字で入力" required minlength="4" sfMaxLength="4" pattern="[0-9]+">
                </div>
                <label class="col-md-12 col-form-label">支店コード</label>
                <div class="col-md-12 form-group">
                  <input type="text" class="form-control col-md-12" [(ngModel)]="singlePayment.btBranchCode"
                         name="btBranchCode" placeholder="支店コードを半角数字で入力" required minlength="3" sfMaxLength="3" pattern="[0-9]+">
                </div>
                <label class="col-md-12 col-form-label">普通</label>
                <label class="col-md-12 col-form-label">口座番号</label>
                <div class="col-md-12 form-group">
                  <input type="text" class="form-control col-md-12" [(ngModel)]="singlePayment.btCardNum"
                         name="btCardNum" placeholder="口座番号を半角で入力" required minlength="7" sfMaxLength="7" pattern="[0-9]+">
                </div>
                <label class="col-md-12 col-form-label">名義</label>
                <div class="col-md-12">
                  <input type="text" class="form-control col-md-12" [(ngModel)]="singlePayment.btAccountName"
                         name="btAccountName" placeholder="全角半角カナおよびスペースで入力" required>
                </div>
              }

              @if (singlePayment.paymentMethod == '1') {
                <label class="col-md-12 col-form-label">クレジットカード番号</label>
                <div class="col-md-12 form-group">
                  <input type="text" class="form-control col-md-12" [(ngModel)]="getGmo.CardNo"
                         name="cardNo" placeholder="クレジットカード番号を半角数字で入力" required minlength="14" sfMaxLength="16" pattern="[0-9]+">
                </div>
                <label class="col-md-12 col-form-label">クレジットカード名義</label>
                <div class="col-md-12 form-group">
                  <input type="text" class="form-control col-md-12" [(ngModel)]="getGmo.HolderName"
                         name="holderName" placeholder="クレジットカード名義を半角で入力" required pattern="[A-Za-z ]+">
                </div>
                <label class="col-md-12 col-form-label">クレジットカード有効期限</label>
                <div class="col-md-4 form-group">
                  <input type="text" class="form-control col-md-12" [(ngModel)]="getGmo.expireMonthAt"
                         name="expireMonthAt" required minlength="2" sfMaxLength="2" pattern="[0-9]+">
                </div>
                <label class="col-md-2 col-form-label">月</label>
                <div class="col-md-4 form-group">
                  <input type="text" class="form-control col-md-12" [(ngModel)]="getGmo.expireYearAt"
                         name="expireYearAt" required minlength="2" sfMaxLength="2" pattern="[0-9]+">
                </div>
                <label class="col-md-2 col-form-label">年</label>
                <label class="col-md-12 col-form-label">クレジットカードセキュリティコード</label>
                <div class="col-md-12">
                  <input type="text" class="form-control col-md-12" [(ngModel)]="getGmo.security"
                         name="security" placeholder="クレジットカードのセキュリティコードを半角数字で入力" required sfMaxLength="4" pattern="[0-9]+">
                </div>
              }
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn bg-close text-white" type="button" data-dismiss="modal"><i class="fa s-icon-cancel"></i>&nbsp;閉じる</button>
            <button class="btn btn-success" type="button" (click)="savePayment()" [disabled]="updatePaymentForm.invalid">
              <i class="fa s-icon-save"></i>&nbsp;保存
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

</div>
@if (profile.profile; as currentMember) {
  @if (editor) { <app-profile-editor-dialog [kind]="editor" [member]="currentMember" [operation]="profile.operation"
    [busy]="profile.busy" [blocked]="profile.blocked" [returnFocus]="editorTrigger"
    (submitted)="saveProfile($event)" (closed)="closeEditor()" /> }
}
